module.exports = __webpack_public_path__ + "static/ZenithSlabDJR-Bold-c9a3f79f399c8868bdcd664b71aaa317.woff2";